
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electronics/mobile-accessories-pos-billing-software",
      function () {
        return require("private-next-pages/electronics/mobile-accessories-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electronics/mobile-accessories-pos-billing-software"])
      });
    }
  